export const fichaDeControl = () => {
    return {
        id: null,
        fecha: null,
        tarea: {},
        id_tarea: null,
        id_empresa: null,
        estandares: [],
        recomendaciones: []
    };
};

export default {
    ficha_de_control: fichaDeControl(),
    id_empresa: null,
    tarea: {
        company: {},
        product: {},
        location: {},
        component: {}
    },
    estandares: [],
    recomendaciones: [],
    recomendaciones_temporales: []
};
